<template>
  <BaseButton primary @click="execute">Add Task</BaseButton>
</template>

<script>
export default {
  props: {
    projectId: {
      type: String,
      required: true,
    },
  },
  methods: {
    execute() {
      this.$modal.show({
        component: () => import('@/components/ProjectTasks/CreateTaskModal.vue'),
        props: {
          projectId: this.projectId,
          defaultData: {},
        },
        on: {
          created: this.editTask,
        },
        hideEvent: 'close',
      });
    },
    editTask(taskId) {
      this.$modal.show({
        component: () => import('@/components/Tasks/TaskModal.vue'),
        props: {
          taskId,
        },
        on: {
          'status-updated': () => {
            this.$emit('updated', taskId);
          },
        },
        hideEvent: 'task-modal:closed',
      });
    },
  },
};
</script>
